module.exports = __webpack_public_path__ + "static/login-banner-c92ee01299e210907213ef24d26c9525.png";